import * as React from 'react';
import PropTypes from 'prop-types';
var SvgSportsWaterNormalXsmall = /*#__PURE__*/React.forwardRef(function (props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M3.84 4a2.88 2.88 0 002.33-1.29A2.88 2.88 0 008.5 4a2.88 2.88 0 002.33-1.29 2.79 2.79 0 004 .78.5.5 0 00-.57-.82 1.89 1.89 0 01-1 .32 2.07 2.07 0 01-1.86-1.54.5.5 0 00-.94 0A2.07 2.07 0 018.5 3a2.07 2.07 0 01-1.86-1.54.52.52 0 00-.94 0A2.07 2.07 0 013.84 3a1.89 1.89 0 01-1-.32.5.5 0 00-.57.82 2.88 2.88 0 001.57.5zM14.22 12.67a1.89 1.89 0 01-1 .32 2.07 2.07 0 01-1.86-1.54.5.5 0 00-.94 0A2.07 2.07 0 018.5 13a2.07 2.07 0 01-1.86-1.54.52.52 0 00-.94 0A2.07 2.07 0 013.84 13a1.89 1.89 0 01-1-.32.5.5 0 10-.57.82 2.88 2.88 0 001.57.5 2.88 2.88 0 002.33-1.29A2.88 2.88 0 008.5 14a2.88 2.88 0 002.33-1.29 2.79 2.79 0 004 .78.5.5 0 00-.57-.82zM4.17 7.71A2.88 2.88 0 006.5 9a2.88 2.88 0 002.34-1.29 2.79 2.79 0 004 .78.5.5 0 00-.57-.82 1.89 1.89 0 01-1 .32 2.07 2.07 0 01-1.96-1.53.5.5 0 00-.94 0A2.07 2.07 0 016.5 8a2.07 2.07 0 01-1.86-1.54.52.52 0 00-.94 0A2.07 2.07 0 011.84 8a1.89 1.89 0 01-1-.32.5.5 0 10-.57.82 2.88 2.88 0 001.57.5 2.88 2.88 0 002.33-1.29z"
  }));
});
SvgSportsWaterNormalXsmall.defaultProps = {
  height: 16,
  width: 16
};
SvgSportsWaterNormalXsmall.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number
};
export default SvgSportsWaterNormalXsmall;